import { Link } from 'react-router-dom';
import { ObfuscatedEmail } from '../components/ObfuscatedEmail';

const servicesData = [
  {
    title: <ObfuscatedEmail email="hello@labzero.eco" displayText={<>Green Champions<br/>Training</>} className="hover:underline hover:text-primary transition-colors text-left" showCopyIcon={false} />,
    description: "Interactive training giving staff the knowledge, tools, resources and confidence to identify, lead and communicate practical sustainability initiatives within their workplace.",
    icon: "/assets/landing-images/Green Champions Training.png",
    alt: "Green Champions Training icon"
  },
  {
    title: <Link to="/about" className="hover:underline hover:text-primary transition-colors">Lab Certification<br/>Platform</Link>,
    description: "Measure, reduce and report your team's footprint through simple assessments, action checklists, tailored resources and Australian-specific and transparent impact reports.",
    icon: "/assets/landing-images/LAB ZER0 Certification Platform.png",
    alt: "Lab Certification Platform icon"
  },
  {
    title: <ObfuscatedEmail email="hello@labzero.eco" displayText={<>Sustainability Grant<br/>Review Service</>} className="hover:underline hover:text-primary transition-colors text-left" showCopyIcon={false} />,
    description: "Evidence-informed reviews for grant applications requiring sustainability statements, carbon reduction plans, environmental impact considerations or resource efficiency commitments.",
    icon: "/assets/landing-images/Sustainability Grant Review Service.png",
    alt: "Sustainability Grant Review Service icon"
  },
  {
    title: <ObfuscatedEmail email="hello@labzero.eco" displayText={<>Sustainable Team<br/>Consultation Service</>} className="hover:underline hover:text-primary transition-colors text-left" showCopyIcon={false} />,
    description: "Tailored support for facilities and organisations seeking practical sustainability solutions across operations, procurement, waste, water, energy, data storage and staff engagement.",
    icon: "/assets/landing-images/Sustainability Consultation Service.png",
    alt: "Sustainable Team Consultation Service icon"
  },
  {
    title: <a href="https://forms.cloud.microsoft/Pages/ResponsePage.aspx?id=DQSIkWdsW0yxEjajBLZtrQAAAAAAAAAAAANAApm4H51UOUg3OEdaTjBMNEdSUE9GOU9UTTBFVDI2OC4u" target="_blank" rel="noopener noreferrer" className="hover:underline hover:text-primary transition-colors">LAB ZER0 Impact<br/>Network</a>,
    description: "Our free network connecting people in wet and dry labs who want to share ideas, learn and support practical environmental sustainability.",
    icon: "/assets/landing-images/LAB ZER0 Impact Network.png",
    alt: "LAB ZER0 Impact Network icon"
  },
  {
    title: <button data-gs-form="4c3bed37-e18a-4e7b-ada0-91f827968f5a" className="hover:underline hover:text-primary transition-colors text-left">LAB ZER0 Newsletter</button>,
    description: "Stay up to date with LAB ZER0 news, resources, upcoming events and practical sustainability insights for wet and dry labs.",
    icon: "/assets/landing-images/LAB ZER0 Newsletter.png",
    alt: "LAB ZER0 Newsletter icon"
  }
];

export default function Home() {
  return (
    <div className="flex flex-col w-full bg-[#fef8ea]">
      <section id="front-page" className="py-16 md:py-24">
        <div className="container mx-auto px-4 flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          
          {/* Left Side: Heading and Login */}
          <div className="lg:w-1/2 flex flex-col items-center text-center">
            <div className="mb-8">
              <h2 id="l0-motto" className="text-4xl md:text-5xl lg:text-7xl">
                Sustainability<br />
                <span className="font-bold">Made Simple</span><br />
                for Aussie Labs
              </h2>
            </div>
            <Link to="/login" className="btn btn-lg no-underline bg-emerald-700 hover:bg-emerald-800 border-none text-white w-full sm:w-auto px-16 h-14 text-lg">
              Get Started
            </Link>
          </div>

          {/* Right Side: Image and Video */}
          <div className="lg:w-1/2 w-full max-w-2xl lg:max-w-none flex flex-col items-center mt-10">
            <div className="relative w-full flex flex-col">
              <img
                src="/assets/landing-images/LAB ZER0 Landing Hero Image.png"
                alt="LAB ZER0 sustainability metrics visualization"
                className="w-full h-auto rounded-t-xs mt-[-28px] transform scale-[1.15] origin-center"
              />
            </div>
          </div>
          
        </div>
      </section>
      <section className='my-20 container mx-auto max-w-7xl px-4'>
          <div className="w-full md:w-[70%] mx-auto rounded-2xl overflow-hidden border border-[#eaddc9]">
                <div className="aspect-video w-full overflow-hidden">
                  <video
                    src="/videos/labzero-home.mp4"
                    autoPlay
                    muted
                    controls
                    playsInline
                    className="w-full object-cover"
                  />
                </div>
              </div>
      </section>

      <section id="services-section" className="w-full pb-16 pt-1">
        <div className="container mx-auto px-4 lg:px-16 max-w-7xl">
          <div className="mb-12">
            <h2 className="text-2xl md:text-3xl font-medium mb-2">What we offer</h2>
            <p className="text-lg md:text-xl text-gray-600 leading-relaxed">
              Ready to reduce your lab’s environmental footprint?<br />
              Explore our services or contact us to discuss how LAB ZER0 can support your team.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {servicesData.map((service, index) => (
              <div key={index} className="flex flex-col items-start gap-4 p-6 bg-white/85 border border-[#eaddc9] rounded-2xl">
                <img src={service.icon} alt={service.alt} className="w-20 h-20" />
                <div className="flex flex-col">
                  <h3 className="text-xl md:text-2xl font-bold leading-tight mb-2">
                    {service.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed text-sm md:text-base">
                    {service.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}